import { FOOTNOTE_CONTAINER_ID } from '../composables/footnotes.composable';
import { infuse } from '../ioc-config';

export function isFootnotePilot() {
  const {
    footnotes: { isPilot },
  } = infuse('config');

  return isPilot;
}

export function scrollToFootnotesContainer() {
  const footnoteContainer: HTMLElement =
    document.getElementById(FOOTNOTE_CONTAINER_ID) ||
    (document.getElementsByTagName('mbmxp-footnote-component')[0] as HTMLElement);

  if (footnoteContainer) {
    const offsetTop = footnoteContainer.offsetTop;

    window.scrollTo({ top: offsetTop, behavior: 'smooth' });
  }
}
